<template>

  <v-tooltip v-if="tooltipText"
             top
             content-class="fab-tooltip">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="fab-btn"
             :class="btnClasses"
             :color="bgColor"
             dark fab
             @click="$emit('click')"
             v-bind="attrs"
             v-on="on">
        <v-icon :color="textColor">{{icon}}</v-icon>
      </v-btn>
    </template>
    <span>
      {{tooltipText}}
    </span>
  </v-tooltip>

  <v-btn v-else
         class="fab-btn"
         :class="btnClasses"
         :color="bgColor"
         dark fab
         @click="$emit('click')">
    <v-icon :color="textColor">{{icon}}</v-icon>
  </v-btn>

</template>

<script>
  export default {
    name: "FabBtn",
    props: {
      customClass: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        required: true
      },
      bgColor: {
        type: String,
        required: true
      },
      textColor: {
        type: String,
        required: true
      },
      size: {
        type: String,
        default: 'md'
      },
      tooltipText: {
        type: String,
        required: false
      }
    },
    computed: {
      btnClasses() {
        return `${this.size} ${this.customClass}`
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_i18n-mixins.scss";

  .fab-btn {
    position: absolute;

    &.x-sm {
      height: 25px;
      width: 25px;
      font-size: 11px;
    }

    &.sm {
      height: 35px;
      width: 35px;
    }

    &.md {
      height: 50px;
      width: 50px;
    }
  }

  .fab-tooltip {
    font-family: var(--primary-font-family);
    font-size: 12px;
    line-height: 18px;
    z-index: 50 !important;
  }
</style>
